/**
 * Created by 2ue on 2017/7/23
 */
import insert from 'insert-css';
import restCss from './dist/rest-css.js';
insert(restCss);